export { ComparisonMatrixSection as FeatureComparisonPricing } from "../credibility-sections"
export type { ComparisonMatrixSectionProps as FeatureComparisonPricingProps } from "../credibility-sections"